import Loading from '@app/statics/Loading';
import SearchIcon from '@assets/images/our-library-au.png';
import type { IStoryList } from '@coreStory/type';
import { useGetHashtagList, useGetStories } from '@coreStory/useCase';
import { Col, Flex, Pagination, Row, Tag } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { BiSearchAlt } from 'react-icons/bi';
import { useLocation, useNavigate } from 'react-router-dom';
import StoryCard from './StoryCard';
import styles from './index.module.scss';

import { EmptyStory, InputCore, ToggleStory } from '@components';
import { useStore } from '@store';

const WebLibrary = () => {
  const { theme } = useStore();
  const getNewHomeStory = useGetStories();
  const getDailyNightStory = useGetStories();
  const getPublicHashtag = useGetHashtagList();
  const getPublicStory = useGetStories();
  const location = useLocation();
  const [publicStoryHashtagAvtice, setPublicStoryHashtagAvtice] =
    useState<any>();
  const [paginatedNewHomeStories, setPaginatedNewHomeStories] = useState<
    IStoryList[]
  >([]);
  const [paginatedDailyNightStories, setPaginatedDailyNightStories] = useState<
    IStoryList[]
  >([]);
  const [paginatedPublicStories, setPaginatedPublicStories] = useState<
    IStoryList[]
  >([]);
  const [filteredNewHomeStories, setFilteredNewHomeStories] = useState<
    IStoryList[]
  >([]);
  const [filteredDailyNightStories, setFilteredDailyNightStories] = useState<
    IStoryList[]
  >([]);
  const [filteredPublicStories, setFilteredPublicStories] = useState<
    IStoryList[]
  >([]);

  const navigate = useNavigate();
  const whisperRef = useRef<HTMLDivElement | null>(null);
  const newHomeNewStoryRef = useRef<HTMLDivElement | null>(null);

  // const currentHour = Number(new Date().toLocaleTimeString().slice(0, 2));
  // const isDay = currentHour > 18 || currentHour < 6;

  useEffect(() => {
    if (location.hash === '#Nights_whisper' && whisperRef) {
      window.scrollTo({
        top: whisperRef?.current?.offsetTop,
        left: 0,
        behavior: 'smooth',
      });
    } else if (location.hash === '#New_home_new_story' && newHomeNewStoryRef) {
      window.scrollTo({
        top: newHomeNewStoryRef?.current?.offsetTop,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [location.hash && whisperRef.current && newHomeNewStoryRef.current]);

  useEffect(() => {
    getPublicStory.mutate({ public: true, hashtagid: 0 });
    getPublicHashtag.mutate({ public: true });
    getNewHomeStory.mutate({ hashtagid: 3, public: true });
    getDailyNightStory.mutate({
      hashtagid: theme === 'night' ? 2 : 1,
      public: true,
    });
  }, []);

  useEffect(() => {
    getDailyNightStory.mutate({
      hashtagid: theme === 'night' ? 2 : 1,
      public: true,
    });
  }, [theme]);

  useEffect(() => {
    getDailyNightStory.data &&
      setFilteredDailyNightStories(getDailyNightStory.data);
    getNewHomeStory.data && setFilteredNewHomeStories(getNewHomeStory.data);
    getPublicStory.data && setFilteredPublicStories(getPublicStory.data);
    getDailyNightStory.data &&
      setPaginatedDailyNightStories(paginateData(getDailyNightStory.data));
    getNewHomeStory.data &&
      setPaginatedNewHomeStories(paginateData(getNewHomeStory.data));
    getPublicStory.data &&
      setPaginatedPublicStories(paginateData(getPublicStory.data));
  }, [
    getPublicStory.isSuccess,
    getNewHomeStory.isSuccess,
    getDailyNightStory.isSuccess,
  ]);

  const paginateData = (
    data: IStoryList[],
    pageNo = 1,
    pageSize = 4,
  ): IStoryList[] => {
    return data.filter(
      (_, index) =>
        index >= (pageNo - 1) * pageSize && index <= pageNo * pageSize - 1,
    );
  };

  const filterData = (data: IStoryList[], filterValue = ''): IStoryList[] => {
    return data.filter(
      (story) =>
        story.StoryText.toLowerCase().trim().includes(filterValue) ||
        story.StoryName.toLowerCase().trim().includes(filterValue) ||
        story.ChildName.toLowerCase().trim().includes(filterValue),
    );
  };

  useEffect(() => {
    setPaginatedDailyNightStories(paginateData(filteredDailyNightStories));
  }, [filteredDailyNightStories]);

  useEffect(() => {
    setPaginatedNewHomeStories(paginateData(filteredNewHomeStories));
  }, [filteredNewHomeStories]);

  useEffect(() => {
    setPaginatedPublicStories(paginateData(filteredPublicStories));
  }, [filteredPublicStories]);

  const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
    const text = event.currentTarget.value.toLowerCase().trim();
    if (text.length >= 3) {
      getNewHomeStory.data &&
        setFilteredNewHomeStories(filterData(getNewHomeStory.data, text));
      getDailyNightStory.data &&
        setFilteredDailyNightStories(filterData(getDailyNightStory.data, text));

      getPublicStory.data &&
        setFilteredPublicStories(filterData(getPublicStory.data, text));
    } else {
      getNewHomeStory.data && setFilteredNewHomeStories(getNewHomeStory.data);
      getDailyNightStory.data &&
        setFilteredDailyNightStories(getDailyNightStory.data);
      getPublicStory.data && setFilteredPublicStories(getPublicStory.data);
      getNewHomeStory.data &&
        setPaginatedNewHomeStories(paginateData(getNewHomeStory.data));
      getDailyNightStory.data &&
        setPaginatedDailyNightStories(paginateData(getDailyNightStory.data));
      getPublicStory.data &&
        setPaginatedPublicStories(paginateData(getPublicStory.data));
    }
  };
  const handlePublicStoryHashtag = (id: any) => {
    setPublicStoryHashtagAvtice(id);
    getPublicStory.mutate({ public: true, hashtagid: id });
  };
  return (
    <>
      <div className={styles['search_box']}>
        <img src={SearchIcon} alt="search" />
        <InputCore
          placeholder="search"
          suffix={<BiSearchAlt />}
          className={styles['input']}
          onInput={(e) => handleInput(e)}
        />
      </div>

      <div className={styles['story_container']}>
        <Flex className={styles['story_header']} align="center">
          <h2 className={styles['title']}>Public Stories</h2>
          {getPublicHashtag.data && (
            <Flex
              style={{
                marginLeft: 20,
                maxWidth: 'calc(100% - 180px)',
                overflowX: 'auto',
                paddingBottom: 5,
              }}>
              <Tag
                style={{
                  borderColor: '#8A8181',
                  cursor: 'pointer',
                  color: '#8A8181',
                  borderRadius: 50,
                  background: 'transparent',
                }}
                onClick={() => handlePublicStoryHashtag(0)}>
                #All
              </Tag>
              {getPublicHashtag.data.map((item) => (
                <Tag
                  key={item.HashtagID}
                  style={{
                    borderColor: '#8A8181',
                    cursor: 'pointer',
                    color:
                      publicStoryHashtagAvtice === item.HashtagID
                        ? '#fff'
                        : '#8A8181',
                    borderRadius: 50,
                    background:
                      publicStoryHashtagAvtice === item.HashtagID
                        ? '#8A8181'
                        : 'transparent',
                  }}
                  onClick={() => handlePublicStoryHashtag(item.HashtagID)}>
                  #{item.Hashtag}
                </Tag>
              ))}
            </Flex>
          )}
        </Flex>

        {getPublicStory.isLoading ? (
          <Loading text="Please wait ..." />
        ) : (
          <>
            {getPublicStory.data && (
              <>
                <Row gutter={[30, 30]}>
                  {paginatedPublicStories.length ? (
                    paginatedPublicStories?.map((item, index) => {
                      return (
                        <Col xl={6} lg={8} md={12} key={index}>
                          <StoryCard {...item} />
                        </Col>
                      );
                    })
                  ) : (
                    <EmptyStory />
                  )}
                </Row>

                <div className={styles['my_story_footer']}>
                  {filteredPublicStories.length ? (
                    <Pagination
                      defaultCurrent={1}
                      size="default"
                      className={styles['pagination']}
                      total={filteredPublicStories.length}
                      defaultPageSize={4}
                      onChange={(page) =>
                        setPaginatedPublicStories(
                          paginateData(filteredPublicStories, page),
                        )
                      }
                    />
                  ) : (
                    ''
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>

      <div className={styles['story_container']}>
        <Flex
          className={styles['story_header']}
          justify="space-between"
          align="center">
          <h2 className={styles['title']} ref={whisperRef}>
            {theme === 'night' ? 'Night’s whisper' : 'Daily adventures'}
          </h2>
          <div className={styles['toggle']}>
            <ToggleStory />
          </div>
        </Flex>
        {getDailyNightStory.isLoading ? (
          <Loading text="Please wait ..." />
        ) : (
          <>
            {getDailyNightStory.data && (
              <>
                <Row gutter={[30, 30]} align={'stretch'}>
                  {paginatedDailyNightStories.length ? (
                    paginatedDailyNightStories.map((item, index) => {
                      return (
                        <Col xl={6} lg={8} md={12} key={index}>
                          <StoryCard {...item} />
                        </Col>
                      );
                    })
                  ) : (
                    <EmptyStory />
                  )}
                </Row>
                <div className={styles['my_story_footer']}>
                  {filteredDailyNightStories.length ? (
                    <Pagination
                      className={styles['pagination']}
                      defaultCurrent={1}
                      total={filteredDailyNightStories.length}
                      defaultPageSize={4}
                      onChange={(page) =>
                        setPaginatedDailyNightStories(
                          paginateData(filteredDailyNightStories, page),
                        )
                      }
                    />
                  ) : (
                    ''
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>

      <div className={styles['story_container']}>
        {getNewHomeStory.isLoading ? (
          <Loading text="Please wait ..." />
        ) : (
          <>
            {getNewHomeStory.data && (
              <>
                <div className={styles['story_header']}>
                  <h2 className={styles['title']} ref={newHomeNewStoryRef}>
                    New Home, New Story
                  </h2>
                </div>
                <Row gutter={[30, 30]}>
                  {paginatedNewHomeStories.length ? (
                    paginatedNewHomeStories?.map((item, index) => {
                      return (
                        <Col xl={6} lg={8} md={12} key={index}>
                          <StoryCard {...item} />
                        </Col>
                      );
                    })
                  ) : (
                    <EmptyStory />
                  )}
                </Row>

                <div className={styles['my_story_footer']}>
                  {filteredNewHomeStories.length ? (
                    <Pagination
                      defaultCurrent={1}
                      size="default"
                      className={styles['pagination']}
                      total={filteredNewHomeStories.length}
                      defaultPageSize={4}
                      onChange={(page) =>
                        setPaginatedNewHomeStories(
                          paginateData(filteredNewHomeStories, page),
                        )
                      }
                    />
                  ) : (
                    ''
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default WebLibrary;
